import "./style.scss";

import $ from "jquery";

$(".work-page-filter__category").each((_, el) => {
  const $wrapper = $(el);
  const $links = $wrapper.find(".work-page-filter__category__links a");

  $links.click((evt) => {
    evt.preventDefault();

    const $target = $(evt.target);
    if ($target.hasClass("active")) return;

    $links.removeClass("active");
    $target.addClass("active");
    $wrapper.attr(
      "data-current-category-slug",
      $target.attr("data-category-slug") || null
    );
    $wrapper.trigger("change:category");
  });
});
